import {moment, resolveTimezone} from "@/src/modules/core/lib/moment";

export function formatBuildLabel(
  buildId: string,
  companyTimezone?: string | null,
): string {
  if (buildId.endsWith("-dev")) {
    return "local dev";
  }

  const timestampMatch = buildId.match(/-(\d{13,})$/);
  if (!timestampMatch) {
    return buildId;
  }

  const builtAt = new Date(Number(timestampMatch[1]));
  if (Number.isNaN(builtAt.getTime())) {
    return buildId;
  }

  return moment(builtAt)
    .tz(resolveTimezone(companyTimezone))
    .format("MMM D, YYYY, h:mm A");
}
